module.exports = __webpack_public_path__ + "static/fluorotechnics-logo-8b7e3751a7d2a8bf4dd3246dddbed6c9.svg";